import React from "react";
import "../style/Registration.css";

function Registration() {
  const handleRegisterClick = () => {
    window.open("https://forms.gle/VkSD9iyETYQ3u6CFA", "_blank");
  };

  const handleEmailClick = (event) => {
    const gmailWebUrl =
      "https://mail.google.com/mail/?view=cm&fs=1&to=conference@iitm.tech";
    const isAndroid = /Android/i.test(navigator.userAgent || "");

    if (!isAndroid) {
      event.preventDefault();
      window.open(gmailWebUrl, "_blank");
    }
    // On Android, let the default mailto: behavior handle it
  };

  return (
    <div className="registration-container">
      <div className="registration-content">
        <h1>Registration</h1>

        <div className="registration-info">
          <p>
            The submission for the Conference may be in the form of descriptive, critical, research
            paper and case studies to mirror theory, research, practice and reflective thinking in
            the above area. Paper should contain abstract ranging from 250-300 words along with at
            least 5 key words.
          </p>
          <p>
            Interested candidate are requested to send the duly filled registration form.
            The candidate who wishes to contribute their submission should send the electronic copy
            of their abstract and paper (if accepted) to the following e-mail address:
            <a
              href="mailto:conference@iitm.tech"
              className="email-link"
              onClick={handleEmailClick}
              title="You will need to sign in to your Google account to email your abstract and paper."
            >
              conference@iitm.tech
            </a>.
          </p>
        </div>

        <div className="fee-section">
          <h2>Registration Fee</h2>

          <div className="fee-table-container">
            <table className="fee-table">
              <thead>
                <tr>
                  <th>Delegates</th>
                  <th>Fees (Rs.)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Students</td>
                  <td>500</td>
                </tr>
                <tr>
                  <td>Research Scholar</td>
                  <td>1000</td>
                </tr>
                <tr>
                  <td>Academicians</td>
                  <td>1200</td>
                </tr>
                <tr>
                  <td>Corporate Delegates</td>
                  <td>1500</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="registration-actions">
          <button
            className="download-form-btn"
            onClick={handleRegisterClick}
            title="You will need to sign in to your Google account to fill in the Google registration form."
          >
            Register Now
          </button>
        </div>
      </div>
    </div>
  );
}

export default Registration;
